import { type StripeCardNumberElementOptions } from '@stripe/stripe-js';

export const CARD_DESKTOP_OPTIONS: StripeCardNumberElementOptions = {
    style: {
        base: {
            color: '#090719',
            fontWeight: '600',
            fontFamily:
                '"Alliance No.1", "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
            fontSize: '20px',
            lineHeight: '20px',
            fontSmoothing: 'antialiased',
            ':-webkit-autofill': {
                color: '#090719',
            },
            '::placeholder': {
                color: '#09071959',
            },
        },
        invalid: {
            iconColor: '#eb1c26',
            color: '#eb1c26',
        },
    },
};

export const CARD_TABLET_OPTIONS: StripeCardNumberElementOptions = {
    style: {
        base: {
            color: '#090719',
            fontWeight: '600',
            fontFamily:
                '"Alliance No.1", "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
            fontSize: '16px',
            lineHeight: '20px',
            fontSmoothing: 'antialiased',
            ':-webkit-autofill': {
                color: '#090719',
            },
            '::placeholder': {
                color: '#09071959',
            },
        },
        invalid: {
            iconColor: '#eb1c26',
            color: '#eb1c26',
        },
    },
};

export const CARD_MOBILE_OPTIONS: StripeCardNumberElementOptions = {
    style: {
        base: {
            color: '#ffffff',
            fontWeight: '600',
            fontFamily:
                '"Alliance No.1", "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
            fontSize: '16px',
            lineHeight: '20px',
            fontSmoothing: 'antialiased',
            ':-webkit-autofill': {
                color: '#ffffff',
            },
            '::placeholder': {
                color: '#ffffff59',
            },
        },
        invalid: {
            iconColor: '#eb1c26',
            color: '#eb1c26',
        },
    },
};
